<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [noChangeLabel]="true"
  (cancelChange)="cancel()"
  [columns]="[]"
  [noSubmit]="true"
  (submitChange)="save()">
  <ng-container class="content">
    <div *ngIf="GoodsFormulaDetailsColumns && GoodsFormulaDetailsColumns.length > 0">
      <kgrid
        #goodsFormulaView
        id="GoodsFormulaView"
        [areaName]="areaName"
        [label]="label"
        [noToolBar]="true"
        [groupable]="false"
        [paging]="false"
        name="GoodsFormulaView"
        [columns]="GoodsFormulaDetailsColumns"
        [dataList]="datList"
        [isEdit]="false"
        [isAdd]="false"
        [isDelete]="false"
        [actions]="actions"
        [actionTregger]="onActionClick"
        reportName="GoodsFormulaView">
      </kgrid>
    </div>
  </ng-container>
</dynamic-form>
